export default __webpack_public_path__ + "static/media/v4.1f81158e.png";